import { useCallback } from "react";
import { IOption } from "./AutocompleteSelect";
import { BaseSelect, BaseSelectProps } from "./Select";
import { dueDateRuleSuggestions } from "libs/datetime-suggestions/dueDateRuleSuggestions";
import { matchDateTimeSuggestions } from "libs/datetime-suggestions/matchDateTimeSuggestions";
import { RelativeDueDate } from "libs/schema";

export interface IRelativeDateTimeOption extends IOption<RelativeDueDate> {}

export interface RelativeDateTimeSelectProps
  extends Omit<BaseSelectProps<IRelativeDateTimeOption, false>, "multiple" | "options" | "loadOptions" | "name"> {}

export function RelativeDateTimeSelect(props: RelativeDateTimeSelectProps) {
  const loadOptions = useCallback(async (input: string) => {
    const suggestions = Object.values(dueDateRuleSuggestions).map((f) =>
      f({
        defaultTimeForSuggestion: "SOP",
        weekStartsOn: "mo",
        weekendStartsOn: "sa",
      }),
    );

    const matchedSuggestions = matchDateTimeSuggestions({
      input,
      suggestions,
      limit: 5,
    });

    return matchedSuggestions.map(
      (s): IRelativeDateTimeOption => ({
        label: s.content!,
        value: {
          id: s.id,
          content: s.content!,
          contentVariables: structuredClone(s.contentVariables),
        },
      }),
    );
  }, []);

  return <BaseSelect<IRelativeDateTimeOption, false> {...props} name="relative-datetime" loadOptions={loadOptions} />;
}
